import { IDictionary, ILanguage } from '@bimser/core';

// Deprecated
export function geti18nValue(value?: IDictionary<string>, currentLanguage?: ILanguage) {
	try {
		if (value && typeof value == 'object' && Object.keys(value).length > 0) {
			if (currentLanguage) {
				return value[currentLanguage.culture] ? value[currentLanguage.culture] : '';
			}
		}

		return '';
	} catch (exp) {
		console.log(exp);
	}
}
